import axios from 'axios';
import settings from '../settings'
const Auth={
    namespaced:true,
    state:()=>({
        status: '',
        token: localStorage.getItem('token') || '',
        userInfo:localStorage.getItem('userInfo') || [],
    }),
    getters: {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
    },
    mutations:{
        auth_request(state){
            state.status = 'loading'
          },
          auth_success(state,data ){
            state.status = 'success'
            state.token = data[0]
            state.userInfo = data[1]
            console.log(data)
          },
          info(state,data ){
            state.status = 'success'
            state.userInfo = data
            console.log(data)
          },
          auth_error(state){
            state.status = 'error'
          },
          logout(state){
            state.status = ''
            state.token = ''
          },
    },
    actions:{
        login({commit}, user){
            return new Promise((resolve) => {
              commit('auth_request')
              axios({url: settings.apiUrl+'/login', data: user, method: 'POST' })
              .then(resp => {
                const token = resp.data.data.token
                const userData =resp.data.data.user
                localStorage.setItem('token', token)
                localStorage.setItem('userInfo',JSON.stringify(userData))
                axios.defaults.headers.common['Authorization'] ="Bearer "+token
                commit('auth_success',[token,userData])
                resolve(resp)
              }).catch(err =>{
                if( err.response ){
                  resolve(err.response)
                  // console.log(err.response); // => the response payload 
              }
              })
                
            })
        },
        logout({commit}){
            return new Promise((resolve) => {
              commit('logout')
              localStorage.removeItem('token')
              localStorage.removeItem('userInfo')
              delete axios.defaults.headers.common['Authorization']
              window.localStorage.clear();
              location.reload();
              resolve()
            })
        },
        info({commit}){
            return new Promise((resolve) => {
              commit('info')
              axios({url: settings.apiUrl+'/user', method: 'GET' })
              .then(resp => {
                const userData =resp.data.data.user
                localStorage.setItem('userInfo',JSON.stringify(userData))
                commit('info',userData)
                resolve(resp)
              }).catch(err =>{
                if( err.response ){
                  resolve(err.response)
                  // console.log(err.response); // => the response payload 
              }
              })
              resolve()
            })
        }
    },
}
export default Auth;